import { render, staticRenderFns } from "./AddDiscountModule.vue?vue&type=template&id=09fd6ba0&"
import script from "./AddDiscountModule.vue?vue&type=script&lang=js&"
export * from "./AddDiscountModule.vue?vue&type=script&lang=js&"
import style0 from "./AddDiscountModule.vue?vue&type=style&index=0&id=09fd6ba0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports